import React from "react";
import { Form } from "react-bootstrap";

const PitchDeckWarningRow = ({ fieldNames, props }) => {
  // if (fieldNames[0] === "numPageViews") {
  //   console.log(" props.state[numPageViews]", props.state.numPageViews);
  //   console.log(" props.state[numSessions]", props.state.numSessions);
  // }

  // Check if any field has a value of "0" while others do not
  const hasIncompleteFields = fieldNames.some((fieldName, index) => {
    return (
      (props.state[fieldName] === undefined &&
        fieldNames.some(
          (otherFieldName, otherIndex) =>
            otherIndex !== index && props.state[otherFieldName] !== undefined
        )) ||
      (props.state[fieldName] === 0 &&
        fieldNames.some(
          (otherFieldName, otherIndex) =>
            otherIndex !== index && props.state[otherFieldName] !== 0
        ))
    );
  });

  return (
    <>
      {hasIncompleteFields && (
        <tr>
          <td colSpan={3} className="idea-checker-table-row">
            <Form.Text className="text-muted-error">
              Please provide all values for analysis.
            </Form.Text>
          </td>
        </tr>
      )}
    </>
  );
};

export default PitchDeckWarningRow;
